<template>
  <div v-if="totalPages > 1" class="d-flex text-center py-3 justify-content-center">
    <div class="pagination flex-wrap">
      <button @click="changePage(1)" :disabled="currentPage === 1" class=""><IconFirst /></button>
      <button @click="changePage(currentPage - 1)" :disabled="currentPage === 1" class=""
        ><IconCaretLeft
      /></button>
      <button v-if="pagesToShow[0] !== 1" @click="changePage(1)">...</button>
      <span class="search-results__seperator"></span>
      <span class="pag-number" v-for="pageNumber in pagesToShow" :key="pageNumber">
        <button @click="changePage(pageNumber)" :disabled="currentPage === pageNumber" class="">
          {{ pageNumber }}
        </button>
      </span>
      <button
        v-if="pagesToShow[pagesToShow.length - 1] !== totalPages"
        @click="changePage(totalPages)"
        >...</button
      >
      <button @click="changePage(currentPage + 1)" :disabled="currentPage === totalPages" class=""
        ><IconCaretRight
      /></button>
      <button @click="changePage(totalPages)" :disabled="currentPage === totalPages" class=""
        ><IconLast
      /></button>
    </div>
  </div>
</template>

<script setup lang="ts">
const pagerStore = usePaginationStore()

const { currentPage, totalPages, pagesToShow, changePage } = pagerStore
</script>
